import { defineModule } from "direct-vuex";
import { moduleActionContext } from "@/store";

export interface RecordStampInterface {
  recordStampId: number | null;
  title: string | null;
}

export const RecordStampState: RecordStampInterface = {
  recordStampId: null,
  title: null,
};

const RecordStampModule = defineModule({
  state: RecordStampState as RecordStampInterface,
  namespaced: true as const,
  modules: {},
  getters: {},
  mutations: {
    setRecordStampId(state, param: number | null) {
      state.recordStampId = param;
    },
    setTitle(state, param: string | null) {
      state.title = param;
    },
  },
  actions: {
    openDialog(context, params: { id: number; title: string | null }) {
      const { commit } = _moduleActionContext(context);
      commit.setTitle(params.title);
      commit.setRecordStampId(params.id);
    },
  },
});
export default RecordStampModule;

/* eslint-disable */
// noinspection JSUnusedLocalSymbols
const _moduleActionContext = (context: any) =>
  moduleActionContext(context, RecordStampModule);